import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CompanyCard } from '@/entities/company'
import { Offcanvas } from '@/entities/offcanvas'
import { useCompany } from '@/shared/api/company'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/reference-books/company/$companyId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { companyId } = Route.useParams()
  const { data: company, isLoading, isError } = useCompany({ id: companyId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка организации')}>
      <CompanyCard company={company?.company} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
